// extracted by mini-css-extract-plugin
export default {"page":"reports-page_page__V-tQp","content":"reports-page_content__bm626"};